var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#072138",
    d: "M37.81.583a.774.774 0 0 0-1.11-.04L28.572 8.24c-.317.3-.328.8-.047 1.134 4.355 5.192 3.961 12.942-1.023 17.662-4.983 4.72-12.745 4.69-17.692.062-.319-.298-.818-.314-1.135-.014L.55 34.78a.774.774 0 0 0-.02 1.11c9.805 9.745 25.65 9.992 35.757.42C46.393 26.74 47.007 10.904 37.81.584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#072138",
    d: "m27.658 8.182-6.666-7.038a.79.79 0 0 0-1.118-.03L2.27 17.785a.79.79 0 0 0-.03 1.117l6.666 7.04c.3.316.8.33 1.118.03L27.628 9.3c.317-.3.33-.8.03-1.118"
  })));
};
export default SvgLogo;